import { Component } from '@verndale/core';
import { constEvent } from '../utils/constants';
import { dispatchGenericEvent } from '../utils/dispatch-events';
import {
  validateField,
  toggleError,
  disableButton,
  enableButton,
  checkErrors,
  validatePassword,
  validateSelect,
  getJSON,
  serializeform
} from '../utils/forms';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $form: this.el,
      $input: this.el._$$('.field__input:not(.field__password)'),
      $submit: this.el._$('.field__submit'),
      $password: this.el._$$('.field__password'),
      $select: this.el._$('.field__select'),
      $error: this.el._$('.form-error'),
      $checkbox: this.el._$$('.field-checkbox')
    };

    this.loadingClass = 'loading';
    this.isAutoFilled = false;
    this.checkAutoFilled();
  }

  addListeners() {
    if (this.dom.$input) {
      this.dom.$input._on('keyup', this.validateInput.bind(this));
      this.dom.$input._on('input', this.validateInput.bind(this));
    }
    if (this.dom.$password) {
      this.dom.$password._on('keyup', this.validatePasswordInput.bind(this));
      this.dom.$password._on('input', this.validatePasswordInput.bind(this));
    }
    if (this.dom.$select) {
      this.dom.$select._on('change', this.validateInput.bind(this));
    }
    if (this.dom.$checkbox) {
      this.dom.$checkbox._on('change', this.validateForm.bind(this));
    }
    this.dom.$form._on('submit', this.handleSubmit.bind(this));
  }

  validatePasswordInput() {
    this.dom.$password.forEach(inputPassword => {
      validatePassword(inputPassword);
    });
    this.validateForm();
  }

  validateInput(e) {
    const $currentInput = e.target;
    if ($currentInput.classList.contains('field__select')) {
      const error = validateSelect($currentInput);
      toggleError($currentInput, error);
    } else {
      const error = validateField($currentInput);
      toggleError($currentInput, error);
    }
    this.validateForm();
  }

  validateForm() {
    if (checkErrors(this.dom.$form)) {
      enableButton(this.dom.$submit);
      return true;
    }
    disableButton(this.dom.$submit);
    return false;
  }

  handleSubmit(e) {
    disableButton(this.dom.$submit);
    if (this.dom.$form.dataset.ajax) {
      e.preventDefault();
      const data = serializeform(this.dom.$form);
      const submitType = this.dom.$form.dataset.onSubmit;
      this.dom.$form.classList.add(this.loadingClass);

      getJSON(this.dom.$form.dataset.endpoint, data).then(response => {
        this.dom.$form.classList.remove(this.loadingClass);
        const redirectUrl = this.dom.$form.dataset.redirectUrl || '/';

        const { success, body, message } = response || {};

        if (success) {
          if (submitType === 'dispatch-event') {
            dispatchGenericEvent(
              constEvent.FORM_SUCCESSFULLY_SUBMITTED,
              {},
              this.dom.$form
            );
          } else {
            const { loginRedirect } = body || {};
            window.location.href = loginRedirect || redirectUrl;
          }
        } else {
          enableButton(this.dom.$submit);
          this.dom.$error.classList.remove('hidden');
          this.dom.$error.innerHTML = message;
        }
      });
    }
  }

  checkAutoFilled() {
    const that = this;
    let autofilledIntervalCounter = 1;
    const autofilledInterval = setInterval(() => {
      autofilledIntervalCounter += 1;
      const inputs = that.dom.$form._$$('input');
      let isAutofilled = false;

      inputs.forEach(input => {
        if (input.matches(':-webkit-autofill')) {
          isAutofilled = true;
        }
      });

      if (isAutofilled) {
        enableButton(that.dom.$submit);
        clearInterval(autofilledInterval)
      } else if (autofilledIntervalCounter > 10) {
        clearInterval(autofilledInterval)
      }
    }, 500);
  }

}

export default Module;
